import React from 'react'
import {formatToMMDDYYYY} from 'app/format/date'

interface Props {
  notes: any[]
  onClick?: (val: any) => void
  isEditable?: boolean
}

const Notes: React.FC<Props> = ({notes}) => {
  return (
    <>
      {notes.map((note: any) => {
        return (
          <div className='d-flex flex-column card-footer py-5'>
            <span className='mt-1 fw-bold fs-5 mb-1 text-break'>{note.title}</span>
            <span className='fs-6 text-muted'>{formatToMMDDYYYY(note.createdAt)}</span>
          </div>
        )
      })}
    </>
  )
}

const EditOrderNotes: React.FC<Props> = ({notes, onClick, isEditable}) => {
  return (
    <>
      {notes.map((note: any) => {
        return (
          <div className='d-flex justify-content-between align-items-center py-3 px-5 border mb-4 rounded border-2 border-gray-400'>
            <div className='d-flex flex-column'>
              <span className='mt-1 fw-bold fs-5 mb-1'>{note.title}</span>
              <span className='fs-6 text-muted'>{formatToMMDDYYYY(note.createdAt)}</span>
            </div>
            {onClick && isEditable && (
              <div>
                <button className='btn btn-link text-primary-active' onClick={() => onClick(note)}>
                  Edit
                </button>
              </div>
            )}
          </div>
        )
      })}
    </>
  )
}

export {EditOrderNotes, Notes}
